import React, {useRef} from 'react';
import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalBody,
	ModalHeader,
	ModalCloseButton,
} from '@chakra-ui/core';
import {Button} from 'components/Button';

const OpenPdfModal = ({pdfUrl, isOpen, onClose = () => {}}) => {
	const initialFocusRef = useRef();

	return (
		<Modal
			closeOnOverlayClick={false}
			isCentered
			isOpen={isOpen}
			onClose={onClose}
			initialFocusRef={initialFocusRef}
		>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>PDF created</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Button
						ref={initialFocusRef}
						rightIcon="external-link"
						size="lg"
						onClick={() => window.open(pdfUrl, '_blank')}
					>
						Open PDF
					</Button>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};

export default OpenPdfModal;
